import { render, staticRenderFns } from "./LearningResource.vue?vue&type=template&id=7e2714ec&scoped=true"
import script from "./LearningResource.vue?vue&type=script&lang=js"
export * from "./LearningResource.vue?vue&type=script&lang=js"
import style0 from "./LearningResource.vue?vue&type=style&index=0&id=7e2714ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2714ec",
  null
  
)

export default component.exports